import { render, staticRenderFns } from "./ConsignmentLink.vue?vue&type=template&id=2ac97233&"
import script from "./ConsignmentLink.vue?vue&type=script&lang=js&"
export * from "./ConsignmentLink.vue?vue&type=script&lang=js&"
import style0 from "./ConsignmentLink.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports